export interface Profile {
  customerId: string;
  customerReference: string;
  customerName: string;
  contactId: string;
  firstName: string;
  lastName: string;
  isRoot: boolean;
  isCorporateQuoterEnabled: boolean;
  isConsumer: boolean;
  isBackOffice: boolean;
  registrationDate: string;
  roles: Role[];
  role: string;
  roleName: string;
  plate: string;
  contractId: string;
  customerType: string;
  delegaArt94LastUpdate: string;
  isFuelCard: boolean;
  statoDelega: boolean;
  statoDelegaArt94: any;
  isSales: boolean;
  email: string;
  salesSetted: boolean;
  sl_reference: string;
  mappingMiles: any;
  isCarSharing: boolean;
  isMulti: boolean;
  lc: number;
  isEnel?: any;
  codiceCapoGruppo?: any;
  exclusionFunctionality?: any;
  valid_from?: any;
  codCostCenter?: any;
  phone?:any;
  contractReference?: string;
  quoteId?: string;
  legalEntity?: string;
  isBroker?: boolean;
}

export interface Role {
  roleId: string;
  roleName: string;
}

export const CustomerServiceRole = [
  "myald_cs_operator",
  "myald_cs_outsourcer",
  "myald_cs_supervisor",
];
